module.exports = __webpack_public_path__ + "img/00013.03f11974.webp";